import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { MDBBootstrapModulesPro  } from 'ng-uikit-pro-standard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
// import { FroalaEditorComponent } from '../common/froala-editor/froala-editor.component';

// import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { fas } from '@fortawesome/pro-solid-svg-icons';
// import { far } from '@fortawesome/pro-regular-svg-icons';
// import { fal } from '@fortawesome/pro-light-svg-icons';

// import 'froala-editor/js/plugins.pkgd.min.js';
// import 'froala-editor/js/third_party/font_awesome.min';
// import 'froala-editor/js/third_party/image_tui.min';

// library.add(fas, far, fal);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // MDBBootstrapModulesPro.forRoot(),
    // FroalaEditorModule.forRoot(),
    // FroalaViewModule.forRoot(),
  ],
  declarations: [

  ],
  exports: [
    // FroalaEditorComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    // FontAwesomeModule,
  ],
  providers: [
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    }
  }

  constructor() {}
  // constructor(library: FaIconLibrary) {
  //   library.addIconPacks(fas, fal, far);
  // }
}
